import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  ImageContainer,
  PageStyles,
  PageTitleStyles,
} from './GreetAIPhrase.styles';

export const ScreenGreetAIPhrase: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Greet AI Phrase',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles background="none">
      <IonContent>
        <LogoWithAppName className="logo-class" />

        <PageTitleStyles
          className="page-title"
          component="h1"
          variant="headline-large"
          align="center"
        >
          Create your Own
          <br />
          <UiTypography variant="inherit" color="gradient" component="span">
            AI Girlfriend
          </UiTypography>
        </PageTitleStyles>

        <ImageContainer>
          <img
            src="../assets/layout-screens/greet-ai-phrase/girl-main.png"
            alt="AI Girlfriend"
            className="main-image"
          />
          <img
            src="../assets/layout-screens/greet-ai-phrase/girl-phrase.png"
            alt="Illustration of Girl Phrase"
            className="phrase-image"
          />
        </ImageContainer>
      </IonContent>

      <OnboardingFooter
        buttonClassName="page-footer-button"
        onContinue={handleNextStep}
        buttonText="Yes"
      />
    </PageStyles>
  );
};
